// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterSection-module--root--3VCbQ","heading":"NewsletterSection-module--heading--1wg8b"};